var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ListingTableFilter",
    {
      attrs: {
        filter: _vm.filter,
        valuesHumanized: _vm.appliedFilterLabels,
        filterConfig: _vm.filterConfig,
        type: "popover"
      },
      on: {
        updateFilter: _vm.updateFilter,
        updateVisibility: _vm.updateVisibility,
        removeFilter: _vm.removeFilter
      }
    },
    [
      _c(
        "template",
        { slot: "filterDropdownContent" },
        [
          _c("CompassInput", {
            ref: "compassMultipleSelectInput",
            staticClass: "listing-filter-popover-users__search",
            attrs: {
              placeholder: _vm.labels.filterablePlaceholder,
              prefixIcon: "search",
              value: _vm.query,
              isEraseable: ""
            },
            on: { "update:value": _vm.handleInput },
            nativeOn: {
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.updateVisibility(false)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                  ) {
                    return null
                  }
                  return _vm.updateVisibility(false)
                }
              ]
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "listing-filter-popover-users__content" },
            [
              _vm.shouldDisplayNoResult
                ? _c("CompassEmptyState", {
                    attrs: {
                      illustrationPath:
                        "/ressources/logged/img/illustrations/no-results.svg",
                      caption: _vm.labels.noResultsLabel
                    }
                  })
                : _c(
                    "div",
                    {
                      staticClass:
                        "listing-filter-popover-users__content--options"
                    },
                    [
                      !_vm.shouldDisplayNoResult
                        ? _c("CompassCheckbox", {
                            attrs: {
                              modelValue: "checkAll",
                              label: _vm.labels.checkAll,
                              indeterminate: _vm.checkboxAllIsIndeterminate,
                              checked: _vm.checkboxAllIsChecked
                            },
                            on: { change: _vm.onCheckAll }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.query !== ""
                        ? _vm._l(_vm.optionsFiltered, function(option) {
                            return _c(
                              "CompassCheckbox",
                              {
                                key: option.value,
                                attrs: {
                                  modelValue: option.value,
                                  checked: _vm.allOptionsChecked.includes(
                                    option.value
                                  ),
                                  showLabel: false
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.onCheckboxChecked(option.value)
                                  }
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "listing-filter-checkbox__label"
                                  },
                                  [
                                    _c("CompassAvatar", {
                                      attrs: {
                                        initials: option.avatar.initials,
                                        size: "extra-small",
                                        type: option.avatar.type,
                                        photo: option.avatar.avatar,
                                        colorType: _vm.getAvatarColor(option)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typographies-paragraph-medium-regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(option.label) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          })
                        : _vm._l(_vm.filter.options, function(group) {
                            return _c(
                              "CompassCheckboxGroup",
                              {
                                key: group.id,
                                attrs: {
                                  label: group.name,
                                  value: _vm.allOptionsChecked.filter(function(
                                    option
                                  ) {
                                    return _vm
                                      .getStaffsId(group.options)
                                      .includes(option)
                                  }),
                                  checkAll: "",
                                  options: _vm.getStaffsId(group.options)
                                },
                                on: {
                                  onCheckAll: function(checked) {
                                    return _vm.onCheckAllGroup(
                                      checked,
                                      _vm.getStaffsId(group.options)
                                    )
                                  }
                                }
                              },
                              _vm._l(group.options, function(option) {
                                return _c(
                                  "CompassCheckbox",
                                  {
                                    key: option.value,
                                    attrs: {
                                      checked: _vm.allOptionsChecked.includes(
                                        option.value
                                      ),
                                      modelValue: option.value,
                                      showLabel: false
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onCheckboxChecked(
                                          option.value
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "listing-filter-checkbox__label"
                                      },
                                      [
                                        _c("CompassAvatar", {
                                          attrs: {
                                            initials: option.avatar.initials,
                                            size: "extra-small",
                                            type: option.avatar.type,
                                            photo: option.avatar.avatar,
                                            colorType: _vm.getAvatarColor(
                                              option
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "typographies-paragraph-medium-regular"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(option.label) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }),
                              1
                            )
                          })
                    ],
                    2
                  )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.shouldDisplayNoResult
            ? _c(
                "div",
                {
                  staticClass:
                    "listing-filter-popover-users__applied-button-wrapper"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "listing-filter-popover-users__applied-button typographies-paragraph-medium-semibold",
                      on: { click: _vm.updateFilter }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t.__("common.actions.apply")) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }